import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { AESKey } from 'src/app/models/non-master-model/AESKey';




const TAG = 'CrypService';

@Injectable({
    providedIn: 'root'
})
export class CrypService {

    constructor(
    ) { }

    encryptStr(text: string) {
        const key = CryptoJS.enc.Utf8.parse(AESKey.key);
        const iv  = CryptoJS.enc.Utf8.parse(AESKey.iv);
  

        const ciphertext = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), key, {
          keySize: 128 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });

        return ciphertext.toString();
    }


    decryptStr(text: string) {
        const key = CryptoJS.enc.Utf8.parse(AESKey.key);
        const iv  = CryptoJS.enc.Utf8.parse(AESKey.iv);


        let decrypted = CryptoJS.AES.decrypt(text, key, {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        decrypted = decrypted.toString(CryptoJS.enc.Utf8);

        return decrypted;
    }


}